import { z } from 'zod'
import {
	THEME_TOKEN_KEYS,
	type AppearanceThemeMode,
	type BrandThemeDefinition,
	type BrandThemePreset,
	type ThemeTokenRecord,
} from './types'

const tokenShape = Object.fromEntries(
	THEME_TOKEN_KEYS.map((key) => [key, z.string().min(1)]),
) as Record<(typeof THEME_TOKEN_KEYS)[number], z.ZodString>

export const appearanceThemeModeSchema = z.enum(['light', 'dark', 'system'])

export const themeTokenRecordSchema = z.object(tokenShape)

export const brandThemePresetSchema = z.object({
	key: z.string().min(1),
	label: z.string().min(1),
	description: z.string().min(1),
	tokens: z.object({
		light: themeTokenRecordSchema,
		dark: themeTokenRecordSchema,
	}),
})

export const brandThemeDefinitionSchema = z.object({
	brandKey: z.string().min(1),
	defaultPreset: z.string().min(1),
	presets: z.record(z.string().min(1), brandThemePresetSchema),
})

export function defineThemeTokens(tokens: ThemeTokenRecord): ThemeTokenRecord {
	return themeTokenRecordSchema.parse(tokens)
}

export function defineBrandThemePreset(
	preset: BrandThemePreset,
): BrandThemePreset {
	return brandThemePresetSchema.parse(preset)
}

export function defineBrandThemeDefinition(
	definition: BrandThemeDefinition,
): BrandThemeDefinition {
	return brandThemeDefinitionSchema.parse(definition)
}

export function parseAppearanceThemeMode(
	value: AppearanceThemeMode | string,
): AppearanceThemeMode {
	return appearanceThemeModeSchema.parse(value)
}
